import {SizeDetector} from './SizeDetector';

declare const THREE: any;

export class PostAccentLightPositionCalculator {

  private rayCaster;
  private rayOrigin;
  private distance = 100;
  private lightToPOffset = 25;
  private postSizeDetector: SizeDetector;

  constructor() {
    this.rayCaster = new THREE.Raycaster();
    this.rayOrigin = new THREE.Vector3();
    this.postSizeDetector = new SizeDetector();
  }

  calculate(post, accentLightSize, normal) {

    const postSize = this.postSizeDetector.detect(post);

    const offset = normal.clone().multiplyScalar(this.distance);
    this.rayOrigin.copy(post.position);
    this.rayOrigin.add(offset);
    this.rayCaster.set(this.rayOrigin, normal.clone().negate());
    const intersection = this.rayCaster.intersectObject(post, true);

    const position = intersection[0].point;
    post.worldToLocal(position);

    position.y = postSize.y / 2 - accentLightSize.y - this.lightToPOffset;

    return position;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/PostAccentLightPositionCalculator.ts